import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Box, Stack, Switch, TextField, } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import PublicIcon from "@mui/icons-material/Public";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { CustomText } from "@corporate-trip-planner-fe/ui-styles";
import { TripPrivacyType } from "./CreateTripForm.type";
var PrivacyParticipantsForm = function (_a) {
    var data = _a.data, updateData = _a.updateData, validationErrors = _a.validationErrors;
    var privacyOptions = [
        {
            id: TripPrivacyType.COMPANY_ONLY,
            title: "Company-only",
            desc: "Only members of your company can see this trip.",
            icon: _jsx(BusinessIcon, {}),
        },
        {
            id: TripPrivacyType.PUBLIC,
            title: "Public",
            desc: "Anyone on Corptrip can find and view this trip.",
            icon: _jsx(PublicIcon, {}),
        },
        {
            id: TripPrivacyType.INVITE_ONLY,
            title: "Private",
            desc: "Only people you invite can see and join this trip.",
            icon: _jsx(LockOutlinedIcon, {}),
        },
    ];
    return (_jsx(Grid, { container: true, spacing: 4, children: _jsx(Grid, { item: true, xs: 12, md: 6, children: _jsxs(Box, { sx: {
                    p: 3,
                    border: "1px solid #e0e0e0",
                    borderRadius: "24px",
                    bgcolor: "#fff",
                }, children: [_jsx(CustomText, { "$fontSize": "20px", "$fontWeight": "700", "$margin": "0 0 4px 0", children: "Trip Privacy" }), _jsx(CustomText, { "$fontSize": "14px", "$color": "#5f6368", "$margin": "0 0 24px 0", children: "Choose who can see and join your trip." }), _jsx(Stack, { spacing: 2, children: privacyOptions.map(function (opt) { return (_jsxs(Box, { onClick: function () { return updateData({ privacy: opt.id }); }, sx: {
                                p: 2,
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                borderRadius: "16px",
                                border: data.privacy === opt.id
                                    ? "2px solid #1a73e8"
                                    : "1px solid #e0e0e0",
                                bgcolor: data.privacy === opt.id ? "#f1f7ff" : "#fff",
                            }, children: [_jsxs(Box, { sx: { flex: 1 }, children: [_jsx(CustomText, { "$fontWeight": "700", "$fontSize": "16px", children: opt.title }), _jsx(CustomText, { "$fontSize": "13px", "$color": "#5f6368", children: opt.desc })] }), _jsx(Box, { sx: {
                                        color: data.privacy === opt.id ? "#1a73e8" : "#5f6368",
                                    }, children: opt.icon })] }, opt.id)); }) }), (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.privacy) && (_jsx(CustomText, { "$fontSize": "12px", "$color": "#d93025", "$margin": "8px 0 0 0", children: validationErrors.privacy })), _jsxs(Box, { sx: {
                            mt: 4,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }, children: [_jsxs(Box, { children: [_jsx(CustomText, { "$fontWeight": "700", children: "Allow Join Requests" }), _jsx(CustomText, { "$fontSize": "13px", "$color": "#5f6368", children: "Users can request to join this trip." })] }), _jsx(Switch, { checked: data.allowJoinRequests, onChange: function (e) {
                                    return updateData({ allowJoinRequests: e.target.checked });
                                } })] }), _jsxs(Box, { flex: 1, sx: { marginTop: "1.5rem" }, children: [_jsx(CustomText, { "$fontSize": "14px", "$fontWeight": "600", "$margin": "0 0 8px 0", children: "Maximum participants *" }), _jsx(TextField, { fullWidth: true, type: "number", label: "How many people can join this?", value: data.maxParticipants, onChange: function (e) {
                                    return updateData({ maxParticipants: Number(e.target.value) });
                                }, error: Boolean(validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.maxParticipants), helperText: validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.maxParticipants })] })] }) }) }));
};
export default PrivacyParticipantsForm;
